import React from "react";
import styled from "styled-components";

import { defaultProps } from "../default-props";

const IconInner = ({ a11yTitle, color, size, icon, theme, ...rest }) => {
  return <svg aria-label={a11yTitle || icon} {...rest} />;
};

IconInner.displayName = "Icon";

const StyledIconWMO = styled(IconInner)`
  ${({ size = "medium", theme: { global: globalConfig }, width, height }) => `
  width: ${width ||
    (globalConfig.icon &&
      globalConfig.icon.size &&
      globalConfig.icon.size[size]) ||
    size};
  height: ${height ||
    (globalConfig.icon &&
      globalConfig.icon.size &&
      globalConfig.icon.size[size]) ||
    size};
  `}
`;

StyledIconWMO.defaultProps = {};
Object.setPrototypeOf(StyledIconWMO.defaultProps, defaultProps);

export { StyledIconWMO };